module.exports = __webpack_public_path__ + "img/google_play.f61f97c5.png";